/**
 * Constantes pour les statuts de disponibilité (frontend)
 * Synchronisés avec backend/constants/availabilityStatus.js
 */

/**
 * Statuts de disponibilité pour les équipements
 * Système simplifié : seulement disponible ou bloqué
 * @enum {string}
 */
export const AVAILABILITY_STATUS = {
  // Équipement libre pour réservation
  AVAILABLE: 'disponible',
  
  // Équipement non disponible (toutes raisons confondues)
  BLOCKED: 'bloquee'
};

/**
 * Groupes de statuts pour faciliter les requêtes
 */
export const AVAILABILITY_GROUPS = {
  // Statuts où l'équipement peut être réservé
  BOOKABLE: [
    AVAILABILITY_STATUS.AVAILABLE
  ],
  
  // Statuts où l'équipement est occupé/indisponible
  OCCUPIED: [
    AVAILABILITY_STATUS.BLOCKED
  ],
  
  // Tous les statuts valides (seulement 2 maintenant)
  ALL: Object.values(AVAILABILITY_STATUS)
};
/**
 * Descriptions des statuts pour l'interface utilisateur
 */
export const AVAILABILITY_DESCRIPTIONS = {
  [AVAILABILITY_STATUS.AVAILABLE]: {
    fr: 'Disponible',
    en: 'Available',
    ar: 'متاح',
    color: '#4caf50',     // Vert
    icon: 'check_circle',
    priority: 1
  },
  [AVAILABILITY_STATUS.BLOCKED]: {
    fr: 'Bloqué',
    en: 'Blocked',
    ar: 'محظور',
    color: '#f44336',     // Rouge
    icon: 'block',
    priority: 2
  }
};

/**
 * Vérifier si une transition de statut est autorisée
 * Système simplifié : transitions entre disponible et bloqué
 * @param {string} fromStatus - Statut actuel
 * @param {string} toStatus - Statut cible
 * @returns {boolean} - True si la transition est autorisée
 */
export const isTransitionAllowed = (fromStatus, toStatus) => {
  // Transitions autorisées dans le système simplifié
  const AVAILABILITY_TRANSITIONS = {
    [AVAILABILITY_STATUS.AVAILABLE]: [
      AVAILABILITY_STATUS.BLOCKED
    ],
    [AVAILABILITY_STATUS.BLOCKED]: [
      AVAILABILITY_STATUS.AVAILABLE
    ]
  };
  
  const allowedTransitions = AVAILABILITY_TRANSITIONS[fromStatus] || [];
  return allowedTransitions.includes(toStatus);
};
